import styled from '@emotion/styled';
import { FC } from 'react';

type Props = {
  className?: string;
};

const Container: FC<Props> = ({ className, children }) => {
  return <Root className={className}>{children}</Root>;
};

const Root = styled('div')(`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`);

export default Container;
